// Original, plain-language readings of the supplied I Ching.pages text.
// Each entry contains the hexagram judgement followed by lines 初 through 上.
// These explain historical wording; they are not predictions or advice.
export const ichingParaphrases = {
  1: [
    '開端順暢，適宜持守正道。',
    '龍潛藏未現，暫時不宜施展。',
    '龍出現在田野；原文說適宜見有德位的人。',
    '君子白天勤勉，夜晚仍戒慎；雖有危險，沒有過失。',
    '龍有時從深淵躍起；沒有過失。',
    '龍飛在天上；原文說適宜見有德位的人。',
    '龍飛得過高，便會有悔恨。'
  ],
  2: [
    '以母馬的柔順而持久為比喻：事情可通達；出行時先失方向，後得依循。西南得同伴，東北失同伴；安守正道則吉。',
    '腳下踏到霜，預示厚冰將至。',
    '正直、端方、廣大；即使不刻意學習，也無所不利。',
    '含藏才華而守正；若參與王事，不居功卻有結果。',
    '像束緊袋口一樣謹言；沒有過失，也沒有讚譽。',
    '穿著黃色下裳，原文評為大吉。',
    '龍在野外交戰，血呈深黃兩色。'
  ],
  3: [
    '草創時可通達，但宜守正；原文說不宜急著遠行，宜建立領導與秩序。',
    '徘徊未進；安住守正為宜，原文亦言利於建立領導。',
    '艱難徘徊，馬隊反覆行進；來者不是盜賊而是求婚者。女子暫不婚配，十年後才成婚。',
    '逐鹿卻沒有嚮導，只會闖進林中；原文勸人及時止步，繼續前行有憾。',
    '馬隊徘徊；去求婚配，原文說無所不利。',
    '恩澤有所蓄而未能廣施；小事守正為吉，大事守正則凶。',
    '馬隊反覆徘徊，悲泣得血淚連連。'
  ],
  4: [
    '啟蒙可以通達：不是教師追求學童，而是學童主動求教。初問可答，反覆輕慢地問便不再答；宜守正。',
    '開導蒙昧；可用刑罰使人知戒，並解除桎梏；若只靠刑罰一路走下去，便有憾。',
    '能包容蒙昧者為吉；迎娶婦人為吉，兒子也能主持家事。',
    '不宜娶見到有財勢男子便失去自持的女子；原文說沒有好處。',
    '困在蒙昧中，令人遺憾。',
    '如孩童般願意受教，原文評為吉。',
    '用強力對付蒙昧；不宜主動侵犯，宜抵禦侵犯。'
  ],
  5: [
    '心中有誠信，光明通達；守正為吉，原文說適宜渡過大河。',
    '在郊外等待；持之以恆便沒有過失。',
    '在沙地等待；雖有些議論，結局仍吉。',
    '在泥中等待，招來敵人。',
    '在流血的險境等待，終於從洞穴走出。',
    '在飲食間等待，守正為吉。',
    '進入洞穴，三位不請自來的客人到了；恭敬對待，結局為吉。'
  ],
  6: [
    '有誠信卻受阻，保持警惕並適可而止則吉，爭到最後則凶；宜見有德位者，不宜涉大川。',
    '不把爭端拖長；雖有些議論，最後為吉。',
    '訴訟未勝，退回家鄉避開；小邑中的人沒有災禍。',
    '憑舊有的德業生活；守正仍有危險，但結局為吉；若為王辦事，不居功。',
    '訴訟未勝，轉而接受命運，改變態度、安守正道，原文評為吉。',
    '訴訟得到公正裁決，原文評為大吉。',
    '即使獲賜華美腰帶，一天之內也可能被奪去三次。'
  ],
  7: [
    '軍隊要守正，並由有經驗的長者統領；原文評為吉而無過。',
    '軍隊出發要依軍紀；紀律不善則凶。',
    '身在軍隊中央統領得宜，沒有過失；君王再三授命。',
    '軍隊或許用車載著死者歸來；原文評為凶。',
    '軍隊退駐一旁，沒有過失。',
    '田中有獵物，可以宣布捕獲；由長子領軍，若由不成熟者率眾而載屍歸來，即使守正也凶。',
    '君主頒布命令，分封建國；不要任用小人。'
  ],
  8: [
    '親近結盟，原文評為吉；再占仍長久守正便無過。心有不安者前來，遲來的人則凶。',
    '真誠地親近他人，沒有過失；誠意像滿缶的酒，終會引來別人，原文評為吉。',
    '從內部建立親近關係，守正為吉。',
    '親近了不適當的人。',
    '與外界的人親近，守正為吉。',
    '公開而坦蕩地結盟；君王狩獵時放走前方的獵物，邑中人不必戒備，原文評為吉。',
    '結盟沒有領頭者，原文評為凶。'
  ],
  9: [
    '小有積蓄而通達；西郊濃雲密布，卻還沒有下雨。',
    '回到原來的道路，哪有過失？原文評為吉。',
    '被牽引著一同返回，原文評為吉。',
    '車輪的輻條脫落，夫妻反目。',
    '懷有誠信，流血與恐懼得以離去，沒有過失。',
    '真誠緊密相連，並與鄰人分享富足。',
    '雨已落下，也已停息，德行有所積累；婦人守正仍有危險。月將圓滿，君子出行則凶。'
  ],
  10: [
    '踩到老虎尾巴，虎卻沒有咬人；原文說事情通達。',
    '樸素地行走，前往沒有過失。',
    '道路平坦；隱居者守正，原文評為吉。',
    '眼有缺陷卻勉強看，腳跛卻勉強走；踩到虎尾而被咬，原文評為凶。又有武人僭居君位之象。',
    '小心翼翼地踩著虎尾，最後為吉。',
    '果決地前行，即使守正也有危險。',
    '回看走過的路，考察其中徵象；周全返歸，原文評為大吉。'
  ],
  11: [
    '微小者離去，宏大者到來；原文評為吉而通達。',
    '拔茅草時連根牽起同類；一同前進，原文評為吉。',
    '包容荒遠之地，敢於徒涉河流，不遺棄遠方，也不徇私朋黨，以中正行事。',
    '平地終會傾斜，往來終會反覆；艱難中守正便無過，不必憂懼，飲食有福。',
    '輕快地與鄰人一同下來，不以富有自恃，以誠信相待而不待告誡。',
    '帝乙嫁女，帶來福祉；原文評為大吉。',
    '城牆倒回壕溝；不宜用兵。從自己的城邑發布命令，即使守正也有憾。'
  ],
  12: [
    '閉塞不通，與人不相交；不利於君子持守，大者離去、小者到來。',
    '拔茅草連帶牽起同類；守正則吉而通達。',
    '包容、承受；小人以為吉，大人則在閉塞中保持通達。',
    '把羞恥藏在心裡。',
    '承受命令而無過，志同道合者也得到福祉。',
    '閉塞暫停，大人為吉；時時想到可能消亡，像繫在桑樹根上一樣警醒。',
    '閉塞終被推翻；先有阻礙，後有歡喜。'
  ],
  13: [
    '在郊野與眾人相聚而通達；原文說可涉大川，君子宜守正。',
    '在門口與人相聚，沒有過失。',
    '只在宗族之內結交，令人遺憾。',
    '在草莽中埋伏兵士，登上高丘觀望，三年沒有出兵。',
    '登上城牆，卻不再攻擊；原文評為吉。',
    '眾人先痛哭，後歡笑；大軍得勝後終於相遇。',
    '在城郊與人相聚，沒有悔恨。'
  ],
  14: [
    '擁有豐富的資源，原文說大為通達。',
    '沒有互相傷害的交往，並非過失；知難而慎，便無過。',
    '大車承載貨物，前往有所作為，沒有過失。',
    '公侯得以向天子獻享；小人無法承擔此事。',
    '不以盛大自矜，沒有過失。',
    '以誠信相交而又有威儀；原文評為吉。',
    '原文說有來自天的保佑，評為吉而無所不利。'
  ],
  15: [
    '謙遜使事情通達；君子能把事情完成到底。',
    '謙而又謙的君子，連渡大河也可行；原文評為吉。',
    '謙遜之名傳揚，守正為吉。',
    '勤勞而謙遜的君子有始有終，原文評為吉。',
    '把謙遜表現在行動中，原文說無所不利。',
    '不以富有自居，和鄰人相處；原文甚至說可用兵征伐，無所不利。',
    '謙名遠揚；原文說可出兵整治自己的邑國。'
  ],
  16: [
    '安樂而有準備；原文說適宜建立諸侯與出兵。',
    '張揚自己的安樂，原文評為凶。',
    '意志像石頭般堅定，不等到一日結束便行動；守正為吉。',
    '仰望著享樂，會有悔恨；遲疑太久，也會有悔恨。',
    '歡樂由此而起，收穫很多；不必疑慮，朋友聚集。',
    '長久帶病，卻始終不死。',
    '沉溺於安樂；事成之後能改變，便沒有過失。'
  ],
  17: [
    '跟隨他人可通達；守正而行，原文說沒有過失。',
    '職位或職責有所變動；守正為吉，出門與人交往會有成果。',
    '只牽繫年少者，便失去成年者。',
    '牽繫成年者，便失去年少者；有所求而得到，安居守正為宜。',
    '跟隨而有所收穫，即使守正仍有危險；若誠實行於正道，光明坦蕩，便沒有過失。',
    '對美好的事物懷有真誠，原文評為吉。',
    '先拘住，再以繩索繫住；君王在西山舉行祭享。'
  ],
  18: [
    '整治積弊可通達；原文說可渡大河，並以甲日前後各三天籌備和善後。',
    '整治父親留下的積弊；兒子能承擔，父親便沒有過失；雖有艱險，結局為吉。',
    '整治母親留下的積弊，不能固執一端。',
    '整治父親留下的積弊，稍有悔意，但沒有大過失。',
    '寬容父親留下的積弊而不加處理，繼續下去會有憾。',
    '整治父親留下的積弊，因而得到稱譽。',
    '不侍奉王侯，把自己的志業置於更高的位置。'
  ],
  19: [
    '居高臨下而接近事物，可通達並宜守正；但原文也提醒，到八月會有危險。',
    '以感通的方式臨近，守正為吉。',
    '以感通的方式臨近，原文說吉而無所不利。',
    '只以甜言蜜語臨近，沒有好處；若已知憂慮，便無過失。',
    '親自臨近，沒有過失。',
    '以智慧臨近，符合君王的職責；原文評為吉。',
    '厚道地臨近，原文評為吉而無過。'
  ],
  20: [
    '祭前洗手而尚未獻祭，眾人以誠敬的目光仰望。',
    '像孩童般觀看；對一般人無過，對君子則顯得不足。',
    '從門縫中窺看；原文認為女子守正為宜。',
    '觀察自己的行為，再決定進退。',
    '觀看國家的光采；原文說適宜成為王的賓客。',
    '反觀自己的行為；君子因此沒有過失。',
    '觀察他人的行為；君子因此沒有過失。'
  ],
  21: [
    '咬開阻隔而使事情通達；原文說適宜運用刑獄。',
    '腳被刑具束住，傷及腳趾；原文說沒有過失。',
    '咬食柔軟的肉，卻傷及鼻子；原文說沒有過失。',
    '咬臘肉卻遇到有毒之物；稍有憾，但沒有過失。',
    '咬帶骨的乾肉，得到金屬箭頭；艱難中守正，原文評為吉。',
    '咬乾肉而得到黃金；守正仍有危險，卻沒有過失。',
    '肩負刑具而遮住耳朵；原文評為凶。'
  ],
  22: [
    '文飾使事情通達；小規模的行動有所助益。',
    '裝飾自己的腳趾，捨車而步行。',
    '裝飾自己的鬍鬚。',
    '文飾而光潤，長久守正為吉。',
    '裝飾得潔白，白馬疾馳而來；來者不是盜賊，而是求婚者。',
    '在丘園中施以裝飾，只帶少量帛禮；雖稍顯寒酸，結局為吉。',
    '以白色作樸素的文飾，沒有過失。'
  ],
  23: [
    '事物正在剝落衰敗，原文說不宜前往有所作為。',
    '床腳開始剝落，正道遭侵蝕；原文評為凶。',
    '床邊框也剝落，正道遭侵蝕；原文評為凶。',
    '從剝落的局面中脫身，沒有過失。',
    '床已剝落到貼身之處；原文評為凶。',
    '像魚依次排列，宮人依序受寵；原文說無所不利。',
    '大果實尚未被吃掉；君子得到車輿，小人卻連居所也失去。'
  ],
  24: [
    '返回原處而通達；往來無病，朋友前來亦無過。沿路往返，七天後又回來；原文說前往有利。',
    '走得不遠便返回，沒有悔恨；原文評為大吉。',
    '好好返回，原文評為吉。',
    '反覆返回，雖有危險，仍沒有過失。',
    '走在隊伍中央，獨自返回。',
    '誠厚地返回，沒有悔恨。',
    '迷失方向而不知返回，原文評為凶，並有災禍；若出兵將大敗，國君受累，十年也難以再征。'
  ],
  25: [
    '不妄為便可通達，宜守正；一旦偏離正道就有災禍，不宜貿然前行。',
    '不妄為而前往，原文評為吉。',
    '不為收穫才耕種，不為熟田才開荒；如此前行有所助益。',
    '無故遭災：有人把牛拴住，過路者得牛，城邑的人卻蒙受損失。',
    '可以守正，沒有過失。',
    '無端生病，不必用藥，病會轉好。',
    '雖不妄為，繼續行動仍有災禍，原文說無所利。'
  ],
  26: [
    '大量積蓄並守正；不只在家取食為吉，原文說可渡大河。',
    '面前有危險，停下來較好。',
    '車輻脫落，車不能前進。',
    '良馬奔馳；在艱難中守正，並日日練習駕車防衛，原文說可以前行。',
    '給小豬設置木欄，使牠尚未長大便受約束；原文評為大吉。',
    '約束長了獠牙的豬，原文評為吉。',
    '通向天空的大道何其開闊；原文說通達。'
  ],
  27: [
    '頤養之道在於守正；觀察如何養人，也要看自己如何取得食物。',
    '捨棄自己珍貴的靈龜，卻盯著別人的食物垂涎；原文評為凶。',
    '顛倒供養的常理，到山丘上求食；前往則凶。',
    '違反頤養之道，即使守正也凶；十年不可用，原文說無所利。',
    '反向尋求供養，原文評為吉；像虎般專注凝視、欲望不斷，也沒有過失。',
    '違反常規，但安居守正仍吉；不可渡大河。',
    '以自己作為眾人頤養所依；雖有危險仍吉，原文說可以渡大河。'
  ],
  28: [
    '房梁彎曲，承受了過重的負擔；原文仍說前往有所助益、事情可通達。',
    '以白茅墊在物品下面，表示慎重，沒有過失。',
    '枯楊長出新芽，老夫娶得年輕妻子；原文說無所不利。',
    '房梁彎曲將折，原文評為凶。',
    '房梁隆起而能承重，原文評為吉；若再有其他問題便有憾。',
    '枯楊開花，老婦得到年輕丈夫；沒有過失，也沒有稱譽。',
    '渡河過深，水淹沒頭頂；原文評為凶，但說沒有過失。'
  ],
  29: [
    '重重險阻之中仍有誠信，心意可以通達；行動尚能受到嘉許。',
    '在重重險境中又掉進深坑，原文評為凶。',
    '身在險境，只求得小小收穫。',
    '前來後去都是險境，倚靠之處亦危險；陷入深坑，不可行動。',
    '用一樽酒、兩盤食物和陶器，從窗中送入簡約的禮物，最後沒有過失。',
    '坑中的水尚未盈滿，但已接近地面；沒有過失。',
    '以繩索綑綁，困在荊棘叢中，三年不得脫身；原文評為凶。'
  ],
  30: [
    '依附於光明，宜守正而通達；飼養母牛，原文評為吉。',
    '腳步紛亂；保持恭敬，便沒有過失。',
    '明亮的黃色附著於中央，原文評為大吉。',
    '太陽西斜：若不敲瓦缶唱歌，便只剩年老的悲嘆；原文評為凶。',
    '突然到來，繼而燃燒、死亡、被棄置。',
    '淚水滂沱，憂傷嘆息；原文卻評為吉。',
    '君王出征，取得勝利，斬敵首領而俘獲其眾；沒有過失。'
  ],
  31: [
    '彼此感應而通達，宜守正；古文稱娶妻為吉。',
    '感應從腳拇指開始。',
    '感應到小腿；貿然行動為凶，安居則吉。',
    '感應到大腿，跟著他人而動；前往會有憾。',
    '守正為吉，悔恨消失；思緒頻繁往來，朋友也隨之響應。',
    '感應只到背部，沒有悔恨。',
    '感應停留在嘴唇、臉頰和舌頭，偏重言語。'
  ],
  32: [
    '長久保持一致而通達，沒有過失；宜守正，原文說前往有利。',
    '過分深入地追求恆久，即使守正也凶，原文說沒有好處。',
    '原文只說悔恨消失，未交代原因。',
    '不能持久保持德行，可能因此蒙羞；即使守正也有憾。',
    '在田野狩獵，卻沒有獵物。',
    '長久保持自己的德行；原文以古代男女角色分別評為婦人吉、男子凶。',
    '不停搖動而不安定，原文評為凶。'
  ],
  33: [
    '退避而仍可通達；小事上守正較有利。',
    '退到最後面，處境危險；原文說不宜前往。',
    '用黃牛皮牢牢綁住，使人無法掙脫。',
    '被牽繫而難以退避，像患病般危險；蓄養臣妾之事原文評為吉。',
    '自願退避，對君子為吉，對小人卻不是。',
    '從容而美好地退避，守正為吉。',
    '寬裕地退避，原文說無所不利。'
  ],
  34: [
    '力量強盛，仍須持守正道。',
    '腳趾先逞強，前行會遇凶；原文說此言可信。',
    '守正，原文評為吉。',
    '小人倚仗強力，君子不如此；守正仍有危險。公羊撞籬笆，角被卡住。',
    '守正為吉，悔恨消失；籬笆打開，羊角不再受困，力量如大車的車軸。',
    '在邊界失去羊，卻沒有悔恨。',
    '公羊撞上籬笆，退不了也進不去；原文說無所利，艱難中仍可轉吉。'
  ],
  35: [
    '康侯得到許多賞賜的馬，君王一日之內多次接見他。',
    '想要前進卻受阻；守正為吉。即使尚未得到信任，寬裕自處也無過。',
    '前進時滿懷憂愁；守正為吉，並從祖母般的長者處受大福。',
    '得到眾人信任，悔恨消失。',
    '前進卻像大老鼠般畏縮，守正仍有危險。',
    '悔恨消失，不必憂慮得失；原文說前行為吉而無所不利。',
    '以角向前衝，只可用來討伐自己的城邑；雖危險仍可吉而無過，固執則有憾。'
  ],
  36: [
    '光明受傷、處境艱難；原文認為在艱難中守正有利。',
    '鳥飛時垂下翅膀；君子在路上三天未食，繼續前往還會被主人議論。',
    '光明受傷，傷在左腿；用強壯的馬救援，原文評為吉。',
    '向南狩獵而捉到首領；不可急於把事情定下來。',
    '進入左腹，探知其中的心意，再走出門庭。',
    '箕子遭逢光明受傷的境況；原文說守正有利。',
    '光明轉為昏暗，起初高登天上，後來墜入地下。'
  ],
  37: [
    '家人相處之道；原文特別說女子守正有利，反映其時的家庭角色觀。',
    '預先在家中立下規範，悔恨便會消失。',
    '不專求個人的成就，在家中主持飲食；守正為吉。',
    '家人間嚴厲約束，雖有悔與危險，結局仍吉；若一味嬉笑放縱，最後有憾。',
    '使家庭富足，原文評為大吉。',
    '君王來到家中，不必憂慮，原文評為吉。',
    '既真誠又有威儀，結局為吉。'
  ],
  38: [
    '彼此乖離之時，小事仍可順利。',
    '悔恨消失；馬走失不必追，它會自行返回。遇見討厭的人也沒有過失。',
    '在小巷中遇見主人，沒有過失。',
    '車被拖住，牛被拉扯；人受額頭與鼻子的刑傷。起初不順，終能有結果。',
    '孤立於乖離中，遇到可以結交的人，彼此真誠；雖有危險而無過。',
    '悔恨消失；宗族之人像咬柔肉般容易相合，前往又有甚麼過失？',
    '孤立時疑心所見如泥豬與鬼車，先張弓後放下；來者不是盜賊而是求婚者，遇雨後原文評為吉。'
  ],
  39: [
    '行路艱難；原文說西南方向有利、東北不利，宜見有德位者，守正為吉。',
    '前往會遇阻，回來卻得到讚譽。',
    '王臣一再遇阻，不是為了自己的緣故。',
    '前往遇阻，便回頭返歸。',
    '前往遇阻，回來便與人聯結。',
    '遭逢大的阻難，朋友前來相助。',
    '前往遇阻，回來有所收穫；原文評為吉，亦宜見有德位者。'
  ],
  40: [
    '困局得以解除；原文說西南有利。若無事須往，返回為吉；若須前往，及早行動為吉。',
    '此爻原文僅稱沒有過失。',
    '在田中捉得三隻狐狸，並得到黃色箭頭；守正為吉。',
    '背負重物卻乘坐車輿，因而招來盜賊；守正仍有憾。',
    '解開腳拇指上的束縛，朋友到來才彼此信任。',
    '君子得以解脫，原文評為吉；也使小人信服。',
    '公侯在高牆上射隼並射獲，原文說無所不利。'
  ],
  41: [
    '有所減損仍保持誠信，原文評為大吉且無過；可守正、可前往。祭享不必豐盛，兩盤食物也足夠。',
    '辦完手邊的事便快去，沒有過失；但要斟酌減損多少。',
    '守正有利，前往則凶；不要減少，反而使之增加。',
    '三人同行，會有一人離開；一人獨行，反而找到朋友。',
    '減輕自己的病痛，便很快有喜事，沒有過失。',
    '有人來增益，價值十朋的龜甲也無法否認；原文評為大吉。',
    '不減少而使之增加，沒有過失；守正為吉，前往有利，得臣卻不據為己有。'
  ],
  42: [
    '增益之時，原文說前往有利，也可渡大河。',
    '可以從事大的建設，原文評為大吉且無過。',
    '有人來增益，昂貴的龜甲也無法否認；長久守正為吉，王用此祭天亦吉。',
    '用所得的增益處理凶事，沒有過失；真誠中正，持玉圭向公侯報告。',
    '行中正之道並告知公侯，得到認同；可據此遷移國都。',
    '以真誠而仁惠的心待人，不問也知原文評為大吉；別人亦真誠稱許其德。',
    '沒有人再來增益，反而有人攻擊；心意不能持久，原文評為凶。'
  ],
  43: [
    '在王庭公開宣布，誠實呼告，雖有危險；先從自己的城邑告知，不宜立刻用兵，原文仍說前往有利。',
    '腳趾先逞強，前往卻不能取勝，令人遺憾。',
    '警惕地呼號；即使夜間有兵戎，也不必過分憂慮。',
    '面頰顯出強硬，可能有凶；君子果斷行事，獨行遇雨、衣服濕透而受怨，仍無過。',
    '臀部受傷，行走遲疑；牽著羊可消除悔恨，卻不相信別人的話。',
    '像莧草被除去般果決；按中道行事便沒有過失。',
    '不再發出呼告，最後有凶。'
  ],
  44: [
    '猝然相遇；原文以古代婚配觀說女子過於強勢，不宜娶她。',
    '把東西繫在金屬制動器上，守正為吉；若貿然前行則見凶，瘦豬也仍在躁動。',
    '袋中有魚，沒有過失；不宜分給賓客。',
    '臀部受傷，行走遲疑；雖有危險，沒有大過失。',
    '袋中沒有魚，便會起凶。',
    '用杞樹葉包住瓜，內含美好的文采；有物從天而降。',
    '相遇時用角相抵，雖有憾，卻沒有過失。'
  ],
  45: [
    '眾人聚集而通達；王到宗廟，原文說宜見有德位者、守正，可用大牲祭祀，也可前往。',
    '誠信未能保持到底，眾人混亂聚散；呼號轉為一笑，不必憂慮，前往無過。',
    '受到引領而聚合，原文評為吉且無過；有誠信便可用簡祭。',
    '聚在一起卻嘆息，沒有收穫；前往雖無過，仍略有遺憾。',
    '原文評為大吉，沒有過失。',
    '聚集時位居其位，沒有過失；若未獲信任，長久守正，悔恨便會消失。',
    '嘆息流淚，沒有過失。'
  ],
  46: [
    '逐漸上升而大為通達；原文說可見有德位者，不必憂慮，向南行為吉。',
    '得到認同而上升，原文評為大吉。',
    '真誠地進行簡祭，沒有過失。',
    '上升進入空無人煙的城邑。',
    '君王在岐山舉行祭享，原文評為吉而無過。',
    '守正為吉，沿著台階逐級上升。',
    '在昏暗中一味上升；原文說宜以不懈的守正為準。'
  ],
  47: [
    '身處困境仍可通達；大人守正，原文評為吉而無過，但所說的話暫不被相信。',
    '臀部困在樹樁間，又走入幽谷，三年不見人。',
    '因酒食而受困，穿朱色禮服的人將來；可用祭享，前行則凶，但沒有過失。',
    '困於石頭，坐在蒺藜上；回到家中卻不見妻子，原文評為凶。',
    '緩緩到來，被金飾的車所困；雖有憾，最終仍有結果。',
    '受割鼻與斷足之刑，又困於紅色禮服之中；後來慢慢脫困，可用祭祀。',
    '被藤蔓纏住，處境不安，說一動便後悔；知悔再前行，原文評為吉。'
  ],
  48: [
    '城邑可改，井的位置不改；汲者往來，井水不增不減。快汲到水時若打破水瓶，原文評為凶。',
    '井中滿是泥，不能飲用；舊井連禽鳥也不來。',
    '井水只流到小魚，汲水的甕又破漏。',
    '井已清理卻無人飲用，令人惋惜；其水可汲，若王明察，眾人都能受益。',
    '以磚石修整井壁，沒有過失。',
    '井水清冽，如寒泉般可飲。',
    '井水已汲上來，不要覆蓋井口；雖有誠信，原文卻記作「無吉」。'
  ],
  49: [
    '到了適當日子，變革才獲信任；原文說大為通達、宜守正，悔恨消失。',
    '用黃牛皮牢固地束縛。',
    '到了適當日子再實行變革；前行為吉，沒有過失。',
    '貿然前行為凶，守正仍有危險；變革之說反覆說明三次，才得到信任。',
    '悔恨消失；以誠信改變舊命令，原文評為吉。',
    '大人的變化像虎斑般鮮明，不用占問也得到信任。',
    '君子的變化像豹紋般顯著，小人只改變表面；前行為凶，安居守正為吉。'
  ],
  50: [
    '以鼎為象，原文評為大吉而通達。',
    '鼎足顛倒，正好倒出污穢；又以妾因其子受重視為喻，原文說無過。',
    '鼎中有食物；敵對者有病，不能靠近我，原文評為吉。',
    '鼎耳變了形，行動受阻，肥美的野雞肉也吃不到；待雨降下，悔意減少，最後為吉。',
    '鼎足折斷，打翻公侯的食物，鼎身沾污；原文評為凶。',
    '鼎有黃色的耳與金屬提環，守正有利。',
    '鼎配玉製提環，原文評為大吉而無所不利。'
  ],
  51: [
    '雷聲震動而通達；起初驚懼，後能談笑。震動遠達百里，主持祭禮的人仍未失手中的器具。',
    '雷來時先驚懼，後能談笑；原文評為吉。',
    '震動帶來危險，貝貨似乎遺失；登上高陵，不必追尋，七日後可得。',
    '震動使人惶惶；仍然前行，沒有災禍。',
    '震動之勢陷進泥中。',
    '震動往來皆危險；原文說沒有重大損失，但仍有事待辦。',
    '震動使人戰慄、眼神不安，前行為凶；若震動還在鄰人而未及己身，便無過，但婚事會有議論。'
  ],
  52: [
    '止住背部而不感知自身；走入庭院卻不見人，原文說沒有過失。',
    '止住腳趾，沒有過失；長久守正有利。',
    '止住小腿，卻無法救助所跟隨的人，因此心中不快。',
    '止在腰部，脊背像被撕裂，危險使內心焦灼。',
    '止住全身，沒有過失。',
    '止住口部，說話有條理，悔恨消失。',
    '厚實地止息，原文評為吉。'
  ],
  53: [
    '如鴻雁漸次前進；古文稱女子出嫁為吉，守正有利。',
    '鴻雁逐漸飛到水邊；幼鳥有危險，也有議論，但沒有過失。',
    '鴻雁逐漸飛到磐石上，安然飲食；原文評為吉。',
    '鴻雁漸至平地；丈夫出征不歸，妻子懷孕卻不能養育，原文評為凶，但可抵禦敵寇。',
    '鴻雁飛到樹上，或能找到平穩的枝椏棲息，沒有過失。',
    '鴻雁漸至山陵；婦人三年不孕，最終阻礙消除，原文評為吉。',
    '鴻雁飛到大道上，羽毛可作禮儀之飾；原文評為吉。'
  ],
  54: [
    '女子出嫁；原文說前行為凶，沒有甚麼有利之處。',
    '女子以陪嫁之妹的身分出嫁；像跛足者仍能走，前行為吉。',
    '眼睛有缺陷卻仍能看；隱居者守正有利。',
    '出嫁時身分低微，又返回作陪嫁之妹。',
    '婚期延誤，晚嫁也有合適的時候。',
    '帝乙嫁女，王女的衣袖反不如陪嫁者華美；月近圓滿，原文評為吉。',
    '女子捧著空筐，男子宰羊卻不見血；原文說沒有好處。'
  ],
  55: [
    '事物盛大而通達；王親臨其境，原文說不必憂慮，宜在日中之時。',
    '遇到相配的主人；雖同處十日也無過，前往有所推重。',
    '遮蔽物太厚，日正中仍見北斗；前往會招疑，若顯明誠意則吉。',
    '遮蔽物更大，日中也昏暗；右臂折傷，原文仍說沒有過失。',
    '遮蔽濃重，日中見北斗；遇到相配的主人，原文評為吉。',
    '賢明的文采到來，得到喜慶與稱譽；原文評為吉。',
    '房屋高大卻把家遮住；窺門而內無人，三年不見人，原文評為凶。'
  ],
  56: [
    '旅居他鄉，只有小小通達；旅途中守正，原文評為吉。',
    '旅人拘泥於瑣事，因此招致災難。',
    '旅人到達住處，帶著資財，得到忠實的童僕。',
    '旅人的住處燒毀，又失去童僕；即使守正仍有危險。',
    '旅居在臨時處所，得到財物與器具，心中卻不快。',
    '射野雞耗去一支箭，最後卻得到稱譽與任命。',
    '鳥巢被焚；旅人先笑後痛哭，又在邊界失牛，原文評為凶。'
  ],
  57: [
    '柔順而漸入，可小有通達；原文說前往、見有德位者均有利。',
    '進退不定；原文說武人式的堅定守正較有利。',
    '謙卑地伏在床下，請史官與巫者紛紛行禮；原文評為吉而無過。',
    '屢次過分謙下，令人遺憾。',
    '悔恨消失，田獵時捕獲三類獵物。',
    '守正為吉、悔恨消失；雖起初不順，終能有成。庚日前後各三日準備，原文評為吉。',
    '伏在床下過分退讓，以致失去資財與斧具；守正仍凶。'
  ],
  58: [
    '喜悅而通達，但仍宜守正。',
    '和順地表達喜悅，原文評為吉。',
    '以誠信表達喜悅，原文評為吉，悔恨消失。',
    '為取悅別人而來，原文評為凶。',
    '反覆商量如何取悅，內心未安；隔開病患，便有可喜之事。',
    '對正在剝落衰敗的事物仍深信不疑，會有危險。',
    '引導他人走向喜悅。'
  ],
  59: [
    '分散而後通達；王到宗廟，原文說可渡大河，守正有利。',
    '用強健的馬救援，原文評為吉。',
    '離散時奔向可倚靠的几案，悔恨消失。',
    '消散只及自身，沒有悔恨。',
    '原有群體分散，原文評為大吉；分散後又聚成山丘般眾多，超乎常人想像。',
    '像汗水流散般傳布重大號令，君王也遷離原處；沒有過失。',
    '流血的危險遠離，走出險境，沒有過失。'
  ],
  60: [
    '節制使事情通達；但過分嚴苦的節制不可長久堅持。',
    '不走出自家門庭，沒有過失。',
    '連外面的門庭也不走出去，原文評為凶。',
    '不懂節制而後嘆息，原文說沒有過失。',
    '安然守節，事情通達。',
    '甘心而適度地節制，原文評為吉；前往也受到嘉許。',
    '節制得過於艱苦，固守則凶；悔恨終會消失。'
  ],
  61: [
    '內心誠實，連以豚魚祭獻也被評為吉；原文說可渡大河，宜守正。',
    '先作戒備，原文評為吉；若另有變故，便不能安寧。',
    '鶴在陰處鳴叫，小鶴應和；有好酒，願與你共飲。',
    '遇到對手，一會兒擊鼓，一會兒停下；一會兒哭泣，一會兒唱歌。',
    '月亮快圓滿，成對的馬失去一匹；原文說沒有過失。',
    '彼此以誠信緊緊連結，沒有過失。',
    '雞鳴聲高入天空，固守這種浮誇，原文評為凶。'
  ],
  62: [
    '稍微越過常度仍可通達，宜守正；小事可做，大事不可。飛鳥留下叫聲，原文說宜下不宜上。',
    '飛鳥因此遭凶。',
    '越過祖父而遇祖母；未見君主而遇臣下，沒有過失。',
    '若不先設防，跟來的人可能傷害自己；原文評為凶。',
    '沒有過失；不過分而能相遇。前往有危險，須戒慎，不可一味固守。',
    '西郊密雲不雨；公侯用弓箭捕獲躲在洞穴中的獵物。',
    '越過而不能相遇，飛鳥也陷入羅網；原文評為凶，稱作災禍。'
  ],
  63: [
    '事情已完成而通達，小事宜守正；起初為吉，末後可能混亂。',
    '拖住車輪，尾巴被水沾濕，沒有過失。',
    '婦人丟失頭飾，不必追趕，七日後可找回。',
    '高宗討伐鬼方，三年才攻克；原文說不可任用小人。',
    '衣服雖有破絮，整天仍保持警戒。',
    '東鄰殺牛獻祭，不如西鄰簡單的禴祭；後者反而真正得到福祉。',
    '頭被水沾濕，處境危險。'
  ],
  64: [
    '事情尚未完成，但仍可通達；小狐快渡河時弄濕尾巴，因而無所利。',
    '尾巴被水沾濕，令人遺憾。',
    '拖住車輪，守正為吉。',
    '尚未渡河，貿然前進為凶；原文又說渡大河有利。',
    '守正為吉，悔恨消失；奮起討伐鬼方，三年後受大國賞賜。',
    '守正為吉，沒有悔恨；君子的光采源於誠信，原文評為吉。',
    '真誠地飲酒，本無過失；但若喝到頭也被沾濕，便失去分寸。'
  ]
};

export function ichingParaphrase(number, linePosition = 0) {
  if (linePosition === 7) return {
    1: '群龍出現，卻沒有一條龍居首；原文評為吉。',
    2: '適宜長久持守正道。'
  }[number] || null;
  return ichingParaphrases[number]?.[linePosition] || null;
}
